import React from 'react'
import Banner from './components/Banner'
import Footer from './components/Footer'
import Products from './components/products/Products'

function Home({handleClick}) {
  return (
    <div>
        
        <Banner/>
        <Products handleClick={handleClick}/>
        <Footer/>
    </div>
  )
}

export default Home